export const channelPartnerList = "CHANNEL_PARTNER_LIST";
export const states = "STATES";
export const cities = "CITIES";